import { CIcon } from '~/icons/types'

export const ciExternalLink: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M21.9 2.6c-.1-.1-.1-.2-.2-.3-.1-.1-.2-.2-.3-.2-.1-.1-.2-.1-.4-.1h-5.1c-.6 0-1 .4-1 1s.4 1 1 1h2.8l-8 8.5c-.4.4-.4 1 0 1.4.2.2.4.3.7.3.3 0 .5-.1.7-.3L20 5.5v2.6c0 .6.4 1 1 1s1-.4 1-1V3c0-.1 0-.3-.1-.4Z'
    },
    {
      d:
        'M21 12.2c-.6 0-1 .4-1 1v5.1c0 .9-.8 1.7-1.7 1.7H5.7c-.9 0-1.7-.8-1.7-1.7V5.7C4 4.8 4.8 4 5.7 4h4.8c.6 0 1-.4 1-1s-.4-1-1-1H5.7C3.7 2 2 3.7 2 5.7v12.6c0 2 1.7 3.7 3.7 3.7h12.6c2 0 3.7-1.7 3.7-3.7v-5.1c0-.6-.4-1-1-1Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'external-link',
  type: 'regular'
}
